import { useEffect, useState } from "react"
import { ColorStyles } from "../../packages/ui"

function base64ToUint8Array(base64: string): Uint8Array {
    const binary = atob(base64)
    const len = binary.length
    const bytes = new Uint8Array(len)
    for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i)
    return bytes
}

async function thumbHashToDataUrl(base64Hash: string): Promise<string> {
    const { thumbHashToRGBA } = await import("thumbhash")
    const hash = base64ToUint8Array(base64Hash)
    const { w, h, rgba } = thumbHashToRGBA(hash)

    const canvas = document.createElement("canvas")
    canvas.width = w
    canvas.height = h

    const ctx = canvas.getContext("2d")
    if (!ctx) throw new Error("No 2D context")

    const imageData = ctx.createImageData(w, h)
    imageData.data.set(rgba)
    ctx.putImageData(imageData, 0, 0)

    return canvas.toDataURL()
}

export function ThumbHashView({ base64 }: { base64: string }) {
    const [dataUrl, setDataUrl] = useState<string>()

    useEffect(() => {
        if (base64) {
            thumbHashToDataUrl(base64)
                .then(setDataUrl)
                .catch((error) => console.error("Error converting ThumbHash to Data URL:", error))
        }
    }, [base64])

    return (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <img src={dataUrl} alt="ThumbHash preview" style={{ width: 128, height: 128 }} />
            <div
                style={{ padding: 16, margin: 16, backgroundColor: ColorStyles["gray-cool"][100] }}
            >
                <code>{base64}</code>
            </div>
        </div>
    )
}
